<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="displayed" class="modal-overlay" :class="size" @click.self="close">
      <dialog class="modal-box animate" @click.self.prevent>
        <header :class="{ 'title': title }">
          <button id="close-modal" type="button" class="dark flat icon" @click="close">
            <svgicon name="close" :alt="$t('close')" />
          </button>
          <div class="title-block">
            <h4 v-if="title" class="no-margin">{{ title }}</h4>
            <slot class="title-action" name="title-action" />
          </div>
        </header>
        <section class="body">
          <slot name="body" />
        </section>
        <footer class="modal-footer">
          <slot name="footer" />
        </footer>
      </dialog>
    </div>
  </transition>
</template>
<script>

import '@/lib/icons/close';

export default {
  props: {
    displayed: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss" scoped>

.modal-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  background-color: rgba($primary-300, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  animation-duration: 0.3s;
}

dialog {
  background-color: white;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0;
  z-index: 101;
  border: none;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @media #{$screen-width-small} {
    border-radius: 0.5rem;
    height: auto;
    width: 42rem;
  }

  .body {
    padding-bottom: 0.5rem;
  }
}

header.title {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid $pearl-300;
  padding: 0.5rem;

  .title-block {
    flex: 2 0 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    margin: auto;

    h4 {
      flex-grow: 2;
      text-align: left;
      margin-left: 0.5rem;
    }
  }
}

footer {
  padding: 0.5rem;
  border-top: 1px solid $pearl-300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;

  &:empty { display: none; }
}

// -- Small Settings

.small {
  @media #{$screen-width-small} {
    .modal-box {
      width: 28rem;
    }
  }
}

// -- FullScreen Settings

.fullscreen {
  @media #{$screen-width-small} {
    .modal-box {
      width: 100%;
      height: 100%;
      border-radius: 0;
    }

    section,
    footer {
      margin: auto;
      padding: 1rem;
      max-width: 32rem;
    }
  }

  @media #{$screen-width-medium} {
    section,
    footer {
      padding: 1rem;
      max-width: 52.25rem;
    }
  }
}

// -- Animation

.v-enter-to dialog {
  animation-name: slideInUp;
  animation-duration: 0.3s;
}

.v-leave-to dialog {
  animation-name: slideOutDown;
  animation-duration: 0.3s;
}

</style>
